import React, { Fragment, Component } from 'react'
import styled from 'styled-components'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
const SideSheet = dynamic(() => import('@ntuctech/devex-tangram/SideSheet'))
const ReactImageZoom = dynamic(() => import('../ReactImageZoom'))
import Link from 'next/link'
import isEmpty from 'lodash/isEmpty'
import dynamic from 'next/dynamic'
import GlobalContext from '../GlobalContext'
import CartCounter, {
  StyledCounterInProductDetail,
  StyledCartButtonInProductDetail,
} from './../CartCounter'
import { CartConsumer } from './../CartProvider'
import { getUserType } from '../../utils/userType'
import { WishlistConsumer } from './../WishlistProvider'
import { EventTrackingConsumer } from '../EventTrackingProvider/EventTrackingProvider'
import Share from '../icons/ProductShare'
import FavouriteInactive from '../icons/FavouriteInactive'
import FavouriteActiveIcon from '../icons/FavouriteActive'
const PromoOffers = dynamic(() => import('../PromoOffer/PromoOffer'))
import PriceDetails from './PriceDetails'
import Carousel from '../Carousel'
import ProductDescription from '../ProductDescription'
const NoImg = dynamic(() => import('../icons/NoImg'))
import SellerNoImgDesktop from '../icons/svg/seller-placeholder-logo.svg'
import SellerNoImgMobile from '../icons/svg/seller-placeholder-logo-mobile.svg'
import ProductCollection from '../ProductCollection'
import { SCREEN_SIZE, Media } from './../../lib/Media'
import ImageSlideShow from '../ImageSlideShow/ImageSlideShow'
const ShoppingListPopup = dynamic(() =>
  import('../ShoppingList/ShoppingListPopup/ShoppingListPopup')
)
import WriteIcon from '../../static/review/write.svg'
import { withRouter } from 'next/router'
const OfferDetails = dynamic(() => import('../OfferDetails/OfferDetails'))
import Text from '../Text/Text'
import Breadcrumb from '../Breadcrumb'
import {
  fetchCategory,
  getCategoryIds,
  getNCheckFn as getNCheck,
  GTM_ENV_VAR as GEV,
  PAGE_TYPES,
} from '../../lib/eventTrackerFunction'
import getPwpOffer, { filterSimplePromotion } from '../../lib/offer'
import {
  isOutOfStock,
  OUT_OF_STOCK,
  IN_STOCK,
} from '../../lib/getInventoryStatus'
import {
  getHandlingTimeDisplayText,
  isJwcTag,
  generateQueryString,
  isBoughtBefore,
} from '../../utils/Utils'
import JwcTag from './JwcTag'
import TruncatedText from '../TruncatedText'
import { isCitrusProductTrackingEnabled } from '../../lib/trackCitrus'
import RatingStars from '../RatingStars/RatingStars'
import { getRatingsConfig } from '../RatingStars/ratingsUtils'
import {
  AMP_EVENT_NAME as AEN,
  CTA_LOCATION_NAME,
  getPageTypeByUrl,
} from '../../lib/amplitude'
import compact from 'lodash/compact'
import {
  getCtaLocation,
  getCtaLocationMeta,
  getCtaSublocation,
  getPreviousCtaLocationMeta,
  getPreviousPageMeta,
  setCtaLocationMeta,
} from '../../lib/utils'
import { getConfigFor } from '../../utils/configService'
import { SPLIT_FEATURES } from '../../utils/constants'
import { get, headers } from '../../lib/fetch'
import Loader from '../Loader/Loader'
import {
  getAddAndRemoveFromCartEcommerceEvent,
  getProductDetailViewEcommerceEvent,
} from '../ProductCard/utils'
import LocalStorageService from '../../utils/LocalStorageService'
import ProductCampaignLabel from '../ProductCampaignLabel/ProductCampaignLabel'
import HealthierChoiceInfoSheetBody from './HealthierChoiceInfoSheetBody'
import { ProductComplexAttribute } from '../ProductComplexAttribute/ProductComplexAttribute'
import {
  getDyFBTExperiments,
  initDyParams,
  setDySession,
  trackingAddToCartForDY,
} from '../../utils/DyUtils'
import { trackProductAddedToCartEvent } from '../../lib/analytics/events/product/ProductAddedToCartEvent'
import { trackProductRemovedFromCartEvent } from '../../lib/analytics/events/product/ProductRemovedFromCartEvent'
import {
  createProductAddedToCartEventParams,
  createProductRemovedFromCartEventParams,
} from '../../lib/analytics/utils/ProductEventHelper'
import { debounce } from 'lodash'
import { TangramFairpriceProvider } from '../TangramFairpriceProvider'
import FindSimilarSection, {
  getFindSimilarSectionConfig,
  PRODUCT_STATUS,
} from './FindSimilarSection/FindSimilar'

const PdpVoucherSwimlane = dynamic(() => import('../PdpVoucherSwimlane'))

const ProductDetailsPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  > div:not(:last-child) {
    margin-bottom: 0.25rem;
  }

  ${SCREEN_SIZE.Only.Mobile} {
    margin-bottom: 5.5rem;
  }

  ${SCREEN_SIZE.Only.MobileL} {
    margin-bottom: 5.5rem;
  }
`
const OfferDetailWrapper = styled.div`
  background-color: #f3f5f7;
  > :not(:last-child) {
    margin-bottom: 0.25rem;
  }
`

const ToolbarContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  background-color: white;
  ${SCREEN_SIZE.From.Hd} {
    padding: 1rem 0 0.5rem 3.5rem;
  }
  ${SCREEN_SIZE.Only.Desktop} {
    padding: ${props =>
      props.isThreeColumnLayout ? '1rem 0 0 2.5rem' : '1.5rem 0 0.5rem 2.5rem'};
  }
  ${SCREEN_SIZE.Only.Tablet} {
    padding: ${props =>
      props.isThreeColumnLayout ? '1rem 0 0 2.5rem' : '1.5rem 0 0.5rem 2.5rem'};
  }
  ${SCREEN_SIZE.Only.MobileL} {
    padding: 1rem 0 1rem 1rem;
  }
  ${SCREEN_SIZE.Only.Mobile} {
    padding: 1rem 0 1rem 1rem;
  }
`

const BreadcrumbContainerFromTablet = styled.div`
  padding: 0.75rem 0;

  display: none;
  ${SCREEN_SIZE.From.Tablet} {
    display: flex;
  }
`

const StyledMedia = styled(Media)`
  flex: 32.33%;
`

const BreadcrumbContainerOnMobile = styled.div`
  margin-right: auto;

  display: none;
  ${SCREEN_SIZE.Only.Mobile} {
    display: flex;
  }
`

const IconDiv = styled.div`
  display: flex;

  cursor: ${props => (props.pointer ? 'pointer' : 'auto')};
  align-items: center;

  > div:not(:last-child) {
    margin-right: 1rem;
  }
  > a {
    text-decoration: none;
  }

  > div:last-child {
    ${SCREEN_SIZE.From.Hd} {
      margin-right: 3.5rem;
    }
    ${SCREEN_SIZE.Only.Desktop} {
      margin-right: ${props => (props.isInside ? '0' : '2.5rem')};
    }
    ${SCREEN_SIZE.Only.Tablet} {
      margin-right: 1rem;
    }
    ${SCREEN_SIZE.Only.Mobile} {
      margin-right: 1rem;
    }
  }
`

const ImageAndDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  ${SCREEN_SIZE.From.Tablet} {
    display: flex;
    flex-direction: row;
  }
`

const ImgAndCarouselDiv = styled.div`
  display: none;
  ${SCREEN_SIZE.From.Tablet} {
    height: 27.5rem;
    padding: ${props =>
      props.isThreeColumnLayout ? '1rem 1rem 2rem 1rem' : '0'};
    display: flex;
    justify-content: center;
    align-content: center;
    position: relative;
    align-self: flex-start;
  }
  ${SCREEN_SIZE.From.Desktop} {
    flex: 32.33%;
  }
`

const CarouselDiv = styled.div`
  position: absolute;
  bottom: 0;
  left: 3rem;
  margin: 1rem;

  ${SCREEN_SIZE.From.Hd} {
    position: inherit;
    bottom: unset;
    left: unset;
    margin: 0 1rem;
    height: 21.5rem;
    overflow-y: auto;
    overflow-x: visible;
    &::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: 0;
  }
`

const ImgDiv = styled.div`
  width: 21.5rem;
  height: 21.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > div {
    width: 21.5rem !important;
    height: 21.5rem !important;
  }
  > div > img + div + div {
    z-index: 100;
  }
`

const Img = styled.img`
  object-fit: fill;
  max-width: 100%;
  height: 100%;
  ${SCREEN_SIZE.Only.Mobile} {
    object-fit: fill;
  }
`
const DetailsDiv = styled.div`
  padding: 1rem;
  display: inline-block;
  max-width: 100%;
  > div {
    margin-bottom: 0.75rem;
  }
  .tagWrapper {
    margin-bottom: 0.5rem;
  }
  ${SCREEN_SIZE.From.Desktop} {
    flex: 32.33%;
    margin-right: 1%;
  }
`

const CounterFixed = styled.div`
  display: flex;

  & button span {
    font-size: 1rem;
    font-weight: 700;
  }

  ${SCREEN_SIZE.Only.Mobile} {
    position: fixed;
    bottom: 1%;
    right: 0;
    width: 100%;
    z-index: 997;
  }
`

const Div = styled.li`
  height: 3.5rem;
  width: 3.5rem;
  border: 0.0625rem solid ${props => (props.selected ? '#1557bf' : '#eaeaea')};
  border-radius: 0.125rem;
  display: inline-block;
  overflow: hidden;
  margin-right: 0.625rem;
  align-items: center;
  cursor: pointer;
  ${SCREEN_SIZE.From.Hd} {
    display: flex;
    margin-right: 0;
    margin-bottom: 0.625rem;
    margin-top: 0rem !important;
    justify-content: center;
  }
`

const ButtonCarosoul = styled.button`
  background: transparent;
  cursor: pointer;
  border: none;
`

const CenterDiv = styled.div`
  ${SCREEN_SIZE.From.Desktop} {
    display: flex;
    background-color: white;
    justify-content: center;
  }
`

const ProductDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  flex-wrap: wrap;
  > div {
    padding-bottom: 1rem;
  }

  ${SCREEN_SIZE.From.Tablet} {
    flex-direction: row;
    padding: 2rem 2rem 0 2rem;
    > div {
      width: calc((100% - 1rem) / 2);
      margin-bottom: 1.5rem;
    }
    > div:nth-child(2n) {
      margin-left: 1rem;
    }
  }
  ${SCREEN_SIZE.From.Desktop} {
    width: 45rem;
  }
`

const PromoOfferContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  > div {
    width: 100%;
    margin: 0.5rem 1rem 0.5rem 0;
  }
  ${SCREEN_SIZE.Only.Mobile} {
    > div {
      margin-right: 0rem;
    }
  }
  ${SCREEN_SIZE.From.Desktop} {
    ${({ isThreeColumnLayout }) =>
      !isThreeColumnLayout &&
      `
      > div {
        width: 45%;
      }
    `};
  }
`

const SidePaddingDiv = styled.div`
  margin-bottom: 4px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
  ${SCREEN_SIZE.From.Tablet} {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  ${SCREEN_SIZE.From.Desktop} {
    padding-top: 1.5rem;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  ${SCREEN_SIZE.From.Hd} {
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }
  ${SCREEN_SIZE.From.Hd} {
    padding-left: 0;
    padding-right: 0;
  }
`

const StyledImg = styled.img`
  height: 21.5rem;
  width: 21.5rem;
`

const PwpFlag = styled(Text)`
  display: inline-flex;
  background: ${props =>
    props.bgcolour
      ? `${props.bgcolour}`
      : defaultTheme.ColorBaseBrandSecondary500};
  border-radius: 4px;
  z-index: 5;
  margin: 0 0.25rem 0 0;
  height: 1rem;
  font-size: 0.75rem;
  padding: 0 0.25rem;
`

const tempData = {
  config: {
    dots: {
      display: true,
      align: 'center',
      paddingSide: 'padding-right',
      paddingValue: '0.5rem',
      activeColor: '#000000',
      inActiveColor: ' #f3f5f7',
      height: '0.375rem',
      width: '0.375rem',
    },
    arrow: {
      hide: true,
    },
  },
}

//  temp data for image slide show config

const ImageSlideShowDiv = styled.div`
  max-height: 17.5rem;
  ${SCREEN_SIZE.From.Tablet} {
    display: none;
  }
`

const MiniToolbarContainer = styled.div`
  display: flex;
  align-items: flex-start;

  > div:last-child {
    display: flex !important;
    margin-left: auto;
    flex: 1;
    justify-content: flex-end;
  }
`

const StyledProductInfoDesktop = styled.div`
  display: none;
  ${SCREEN_SIZE.From.Desktop} {
    display: block;
    flex: 32.33%;
    margin-right: 1rem;
  }
`

const StyledProductInfo = styled.div`
  display: none;
  ${SCREEN_SIZE.Below.Desktop} {
    display: block;
  }
  ${SCREEN_SIZE.Only.Desktop} {
    display: none;
  }
`

const StyledSellerInfoCard = styled.div`
  padding: 1rem;
  background-color: #f3f5f7;
  ${SCREEN_SIZE.Below.Desktop} {
    background-color: #fff;
  }
  ${SCREEN_SIZE.Only.Desktop} {
    background-color: #f3f5f7;
  }
  ${SCREEN_SIZE.Only.Tablet} {
    padding: 1rem 5rem;
  }
`

const StyledSellerInfoCardSection = styled.div`
  display: flex;
  margin-bottom: 1rem;

  :last-child {
    margin-bottom: 0;
  }
`

const StyledSellerLogo = styled.div`
  margin: 0 0.75rem 0 0;
  width: 2.5rem;
  max-width: 2.5rem;
  display: flex;
  align-items: center;

  > img,
  svg {
    border-radius: 3.125rem;
    width: 2.5rem;
    height: 2.5rem;
  }

  ${SCREEN_SIZE.From.Tablet} {
    width: 3rem;
    max-width: 3rem;
    > img,
    svg {
      border-radius: 3.125rem;
      width: 3rem;
      height: 3rem;
    }
  }
`

const SellerRow = styled.div`
  display: flex;
`

const StyledSellerDetails = styled.div`
  font-size: 0.75rem;
  font-weight: normal;
  line-height: 1.43;
  color: ${defaultTheme.ColorBaseMineShaft700};
  flex-direction: row;
  display: flex;

  ${SCREEN_SIZE.From.Desktop} {
    flex-direction: column;
    font-size: 0.875rem;
  }

  ${SCREEN_SIZE.Below.Tablet} {
    flex: 1;
    align-items: center;
  }

  strong {
    font-weight: bold;
  }
`

const DetailSection1 = styled.div`
  display: flex;
  flex-direction: column;

  ${SCREEN_SIZE.Below.Tablet} {
    flex: 1;
    align-items: flex-start;
  }
  ${SCREEN_SIZE.Only.Mobile} {
    > span:first-child {
      display: none;
    }
  }
`
const SingleLineTruncation = styled.div`
  display: block;
  width: calc(100vw - 9.5rem);
  ${SCREEN_SIZE.From.Tablet} {
    flex-direction: column;
    width: calc(100vw - 21rem);
  }

  strong,
  span {
    display: block;
    height: 1rem;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  ${SCREEN_SIZE.From.Desktop} {
    display: none;
  }
`

const DetailSection2 = styled.div`
  display: flex;
  align-items: flex-start;
`

const StyledSellerLink = styled.a`
  font-size: 0.75rem;
  font-weight: bold;
  line-height: 1.43;
  color: ${defaultTheme.ColorBaseBrandPrimary500};
  text-decoration: none;

  ${SCREEN_SIZE.From.Desktop} {
    font-size: 0.875rem;
  }
`
const StyledSection = styled.div`
  width: 100%;
  padding: 0 0.375rem;
  margin: 0 auto;
  ${SCREEN_SIZE.From.Desktop} {
    width: 45rem;
    padding: 0 1.375rem;
  }
  #fpBVContainer .bv-action-bar {
    display: none !important;
  }
`

const StyledWrap = styled.div`
  background-color: white;
`

const StyledWriteReview = styled.a`
  display: inline-block;
  line-height: 1.5rem;
  padding-left: 2rem;
  text-decoration: none;
  font-size: 0.75rem;
  margin-left: auto;
  color: #1557bf;
  font-weight: bold;
  img {
    display: inline-block;
    height: 1.5rem;
    width: 1.5rem;
    padding-right: 0.25rem;
  }
`

const StyledWriteWrap = styled.div`
  display: flex;
  padding: 2rem 1rem 1rem;
  h5 {
    font-weight: bold;
  }
`
const StyledFlex = styled.div`
  display: flex;
  ${SCREEN_SIZE.From.Tablet} {
    display: block;
  }
`

const TopComplementaryProductsSwimlaneContainer = styled.div`
  margin-bottom: -0.5rem !important;

  ${SCREEN_SIZE.From.Tablet} {
    margin-bottom: 0;
  }
`

const SimilarProductsSwimlaneContainer = styled.div`
  margin-bottom: ${props =>
    props.complementarySwimlaneEnabled ? '-1.5rem !important' : '0 !important'};

  scroll-margin-top: ${props => props.headerHeight / 16}rem;
`

const MarketplaceDeliveryInfoContainer = styled.div`
  margin-top: 1rem;
  color: #333333;
`

const MarketplaceDeliveryInfoTitle = styled.div`
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.25rem;
`

const MarketplaceDeliveryInfoText = styled.div`
  font-size: 0.875rem;
  line-height: 1.25rem;
`

export const MarketplaceDeliveryInfo = ({
  deltime,
  itemIsOutOfStock,
  isDonation,
  isNewSellerInfoEnabled,
}) => {
  if (itemIsOutOfStock || !deltime) {
    return null
  }
  return (
    <MarketplaceDeliveryInfoContainer>
      <MarketplaceDeliveryInfoTitle>
        Delivered by {isDonation ? 'FairPrice' : deltime}
      </MarketplaceDeliveryInfoTitle>
      <MarketplaceDeliveryInfoText>
        {isDonation ? (
          <p>
            This donation goes towards charities and families in need. It is not
            eligible for discounts, Linkpoints, and does not count towards free
            delivery minimum.
          </p>
        ) : (
          <>
            <p>
              We will need more time to get this item from the seller and
              deliver to you.
            </p>
            {isNewSellerInfoEnabled && (
              <>
                <p>
                  FairPrice Group E-Vouchers are not valid for Marketplace
                  purchases.
                </p>
                <p>
                  Invoices for Marketplace orders are issued by sellers and may
                  not be available for all purchases.
                </p>
              </>
            )}
          </>
        )}
      </MarketplaceDeliveryInfoText>
      {isDonation && (
        <StyledSellerLink
          href="https://help.fairprice.com.sg/hc/en-us/categories/50503237326617-General-Terms-and-Conditions-for-Donations"
          target="_blank"
        >
          Learn more
        </StyledSellerLink>
      )}
    </MarketplaceDeliveryInfoContainer>
  )
}

class ProductDetails extends Component {
  constructor(props) {
    super(props)
    let isThreeColumnLayout = false
    const productInfo = props.data?.product?.data?.page?.layouts[0]?.value || {}
    if (productInfo.seller && !isEmpty(productInfo.seller)) {
      isThreeColumnLayout = true
    }
    this.similarProductsRef = React.createRef()
    this.state = {
      showList: false,
      expandedOffers: {},
      isThreeColumnLayout,
      enableZoom: false,
      isJwcTagApplicable: false,
      selectedImageIndex: props.selectedImageIndex || 0,
      currentImage: props.preloadProductImageUrl,
      ratingsConfig: getRatingsConfig() || {},
      complementaryProductsData: null,
      complementaryProductsDataLoading: false,
      isHealthierChoiceInfoSheetOpen: false,
      visibleOnScroll: props.isSwimlaneEnabled || false,
      atcData: null,
      headerHeight: 0,
    }

    this.handleShowList = this.handleShowList.bind(this)
    this.productDetailsCardEvent = this.productDetailsCardEvent.bind(this)
    this.productCartAction = this.productCartAction.bind(this)
    this.extraEventTracking = this.extraEventTracking.bind(this)
    this.handleExpandedOffersUpdate = this.handleExpandedOffersUpdate.bind(this)
    this.onHandleTrackOnBrandClick = this.onHandleTrackOnBrandClick.bind(this)
    this.checkIfSellerInfoAvailable = this.checkIfSellerInfoAvailable.bind(this)
    this.renderSellerInfo = this.renderSellerInfo.bind(this)
    this.renderShortlistAndShare = this.renderShortlistAndShare.bind(this)
    this.onHandleTrackOnSellerClick = this.onHandleTrackOnSellerClick.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.onInteraction = this.onInteraction.bind(this)
    this.fetchPDPVoucherSwimlane = this.fetchPDPVoucherSwimlane.bind(this)
    this.trackHBPDietaryGA = this.trackHBPDietaryGA.bind(this)
    this.hpbImpressionSideSheet = this.hpbImpressionSideSheet.bind(this)
    this.hpbPopConnectorClickedAmp = this.hpbPopConnectorClickedAmp.bind(this)
    this.hpbPopConnectorClickedGA = this.hpbPopConnectorClickedGA.bind(this)
    this.updateAddToCartData = this.updateAddToCartData.bind(this)
    this.trackSegmentAddToCart = debounce(
      this.trackSegmentAddToCart.bind(this),
      500
    )
  }
  onScroll() {
    this.setState({
      visibleOnScroll: true,
    })
    window.removeEventListener('scroll', this.onScroll, false)
  }
  /* istanbul ignore next */
  onInteraction() {
    this.setState({
      enableZoom: true,
    })
    document
      .getElementById('zoomTarget')
      .removeEventListener('mousemove', this.onInteraction, false)
  }

  getComplementarySwimlanePosition = () => {
    const complementaryProductLayout =
      this.props.data.product?.data?.page?.layouts?.find(
        layout => layout?.name === 'ComplementaryProducts'
      )
    if (!complementaryProductLayout) {
      return null
    }
    // Treatment A: complementary swimlane not enabled
    // Treatment B: bottom complementary swimlane enabled
    // Treatment C: top complementary swimlane enabled
    const complementarySwimlanePositionByTreatment = {
      A: null,
      B: 'bottom',
      C: 'top',
    }
    const { variant: treatment } = getConfigFor(
      SPLIT_FEATURES.COMPLEMENTARY_SWIMLANE_ENABLED
    )

    return complementarySwimlanePositionByTreatment[treatment]
  }

  checkIfSellerInfoAvailable() {
    const { data } = this.props
    if (!this.state.isThreeColumnLayout) {
      const productInfo = data?.product?.data?.page?.layouts[0]?.value || {}
      if (productInfo.seller && !isEmpty(productInfo.seller)) {
        this.setState({ isThreeColumnLayout: true })
      }
    }
  }

  // Capturing event share action.
  extraEventTracking(value) {
    // For tracking we are calling this function to send our events in format
    // to event tracking system like GA
    this.productDetailsCardEvent({
      eventAction: 'Share',
      eventCat: 'Product-Core',
      value,
      amplitudeEventName: '',
    })
  }

  handleShowList(event, value) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
      const details = this.props.data.product.data.page.layouts[0].value
      const isAddToWishlist = !this.props.wishlistConsumer.includes(details)
      // Event tracking for mark item as favourite or save to wishlist.
      this.productDetailsCardEvent({
        eventAction: 'Shortlist',
        eventCat: 'Product-Core',
        value,
        amplitudeEventName: isAddToWishlist
          ? AEN.PRODUCT_ADDED_TO_LIST
          : AEN.PRODUCT_REMOVED_FROM_LIST,
        delta: isAddToWishlist ? 1 : -1,
      })
      this.setState({
        clientX: event.clientX,
        clientY: event.clientY,
      })
    }
    this.setState(prevState => {
      return {
        showList: !prevState.showList,
      }
    })
  }

  componentDidMount() {
    this.productDetailView()
    const layout = this.props.data?.product?.data?.page?.layouts[0] || {}
    const tags = layout?.value?.tags || []
    const isJwcTagApplicable = isJwcTag(tags)
    this.setState({ isJwcTagApplicable: isJwcTagApplicable })
    window.addEventListener('scroll', this.onScroll, false)
    setCtaLocationMeta([this.props.data?.product?.data?.page?.entity?.slug])
    if (this.getComplementarySwimlanePosition()) {
      this.fetchComplementaryProducts()
    }
    document
      .getElementById('zoomTarget')
      .addEventListener('mousemove', this.onInteraction)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll, false)
    const zoomTarget = document.getElementById('zoomTarget')
    if (zoomTarget) {
      zoomTarget.removeEventListener('mousemove', this.onInteraction)
    }
  }

  fetchComplementaryProducts = async () => {
    const userKey = window?.__NEXT_DATA__?.props?.userKey

    const productInfo = this.props.data.product.data.page.entity
    const basePath = 'product/v2'
    // Added Algopers params
    const { configuration } = getConfigFor(
      SPLIT_FEATURES.ALGOLIA_PERSONALISATION
    )
    const { personalisationSettings } = configuration

    const queryString = generateQueryString({
      personalisationApi: 'pdp_plusone_config_a',
      page: 1,
      pageType: 'pdp_plusone_config_a',
      storeId: this.props.checkoutAddress?.storeId,
      trackinfo: productInfo?.id,
      algopers: personalisationSettings,
      slug: this.props?.data?.query?.slug,
      orderType: getUserType() === 'B2B' ? 'B2B' : 'DELIVERY',
      clientItemId: this.props.data.product.data.page.entity.clientItemId,
      experiments: getDyFBTExperiments(true),
    })
    try {
      // DY
      const dyParams = initDyParams()
      this.setState({ complementaryProductsDataLoading: true })
      const response = await get(`${basePath}${queryString}${dyParams}`, {
        headers: {
          ...headers(this.props.router),
          'x-device-Id': userKey,
        },
      })
      const metaData = response?.data?.metaData
      setDySession(metaData)
      this.setState({ complementaryProductsData: response?.data })
      // eslint-disable-next-line no-empty
    } catch (e) {
    } finally {
      this.setState({ complementaryProductsDataLoading: false })
    }
  }

  productDetailView() {
    const { data, track, checkoutAddress, countOf, remoteConfig } = this.props
    const { ratingsConfig } = this.state
    const productInfo = data.product.data.page.entity
    const productDetails = data.product.data.page.layouts[0]
    const storeSpecific = productDetails.value.storeSpecificData[0]
    const statistics = productDetails?.value?.reviews?.statistics || {}
    const categoryList = fetchCategory(productInfo.primaryCategory)
    const offerPrice = (storeSpecific.mrp - storeSpecific.discount).toFixed(2)

    const { bulkOrderThreshold, stockOverride } = productDetails
    const storeBulkOrderThreshold =
      (stockOverride && stockOverride.storeBulkOrderThreshold) || 0
    const itemIsOutOfStock = isOutOfStock({
      value: countOf(productDetails),
      stock: storeSpecific.stock,
      unlimitedStock: storeSpecific && storeSpecific.unlimitedStock,
      bulkOrderThreshold,
      storeBulkOrderThreshold,
      checkoutAddress,
    })

    const ctaSublocation = getCtaSublocation()
    const eventAction = 'ProductDetailView'

    const isProductBoughtBefore =
      productDetails?.value?.pastPurchases &&
      isBoughtBefore(productDetails?.value?.pastPurchases)
        ? 'yes'
        : 'no'
    const event = {
      [GEV.EVENT_CAT]: 'Ecommerce-Engagement',
      [GEV.EVENT_ACTION]: eventAction,
      [GEV.EVENT_LABEL]: `Prod=${getNCheck(productInfo, 'name')}`,
      [GEV.PROD_ID]: getNCheck(productInfo, 'clientItemId'),
      [GEV.PRODUCT_ID_ZOP]: getNCheck(productInfo, 'id'),
      [GEV.PROD_NAME]: getNCheck(productInfo, 'name'),
      [GEV.PROD_CUR]: getNCheck(storeSpecific, 'currency.name'),
      [GEV.PROD_BRAND]: getNCheck(productInfo, 'brand.name'),
      [GEV.RETAIL_PRICE]: parseFloat(getNCheck(storeSpecific, 'mrp', ''))
        .toFixed(2)
        .toString(),
      [GEV.OFFER_PRICE]: offerPrice ? offerPrice.toString() : '',
      [GEV.PROD_CAT]: 'Retail',
      [GEV.INVTRY_COUNT]: getNCheck(storeSpecific, 'stock'),
      [GEV.PAGE_TYPE]: PAGE_TYPES.PRODUCT_DETAIL,
      [GEV.ECOMM_DIMENSION61]: itemIsOutOfStock ? OUT_OF_STOCK : IN_STOCK,
      [GEV.AMPLITUDE_IS_PAST_PURCHASE]: isProductBoughtBefore,
      [GEV.SELL_NAME]: productInfo?.seller?.name || 'Fairprice',
      [GEV.AMPLITUDE_EVENT_NAME]: AEN.PRODUCT_DETAILS_VIEWED,
      [GEV.SNIPPET_VERSION]: 'ga4',
      [GEV.EVENT_CAT]: 'Ecommerce-Engagement',
      [GEV.EVENT_ACTION]: 'ProductDetailView',
      [GEV.AMPLITUDE_CTA_LOCATION]: getCtaLocation(),
      [GEV.AMPLITUDE_CTA_SUBLOCATION]: ctaSublocation,
      [GEV.PRODUCT_POSITION]: getPreviousPageMeta()?.productPosition,
      ...getProductDetailViewEcommerceEvent({
        productInfo: productDetails.value,
        eventAction,
        categoryList,
        storeSpecific,
        itemIsOutOfStock,
        remoteConfig,
        checkoutAddress,
        statistics,
        shouldTrackReviews: Boolean(
          ratingsConfig?.isFeatureEnabled && ratingsConfig?.isPdpStarsEnabled
        ),
      }),
    }
    const metaData = JSON.parse(LocalStorageService.getItem('metaData') || '{}')
    if (metaData) {
      event[GEV.AMPLITUDE_EVENT_TYPE] = 'click'
      event[GEV.AMPLITUDE_EVENT_SCOPE] = 3
      event[GEV.AMPLITUDE_SEARCH_QUERY_ID] = metaData?.queryId
      event[GEV.AMPLITUDE_SEARCH_INDEX_NAME] = metaData?.indexName
      event[GEV.PRODUCT_POSITION] = metaData?.productPosition
    }
    if (productInfo.metaData && productInfo.metaData['Storage Information']) {
      event[[GEV.STORAGE]] = productInfo.metaData['Storage Information']
    }

    const keys = Object.keys(categoryList)
    keys.forEach(item => {
      event[item] = categoryList[item]
    })
    track(event)
    LocalStorageService.removeItem('metaData')
  }

  fetchPDPVoucherSwimlane(id, primaryCategory, details) {
    const { variant: voucherTreatment } = getConfigFor(
      SPLIT_FEATURES.FE_DIS_PDP_VOUCHERS
    )
    const getSecondaryCategoriesIds =
      details?.secondaryCategoryIds &&
      Array.isArray(details?.secondaryCategoryIds)
        ? details?.secondaryCategoryIds?.join()
        : ''
    const categoriesIds = `${getCategoryIds(
      primaryCategory
    ).trim()},${getSecondaryCategoriesIds.trim()}`

    return voucherTreatment !== 'A' ? (
      <PdpVoucherSwimlane
        productId={id}
        categoryIds={categoriesIds}
        storeId={this.props?.checkoutAddress?.storeId}
        voucherTreatment={voucherTreatment}
        isThreeColumnLayout={this.state.isThreeColumnLayout}
      />
    ) : null
  }

  trackHBPDietaryGA() {
    const { track } = this.props
    const event = {
      [GEV.EVENT]: 'hpb_icon_clicked',
      [GEV.EVENT_CAT]: 'HpbApp',
      [GEV.EVENT_ACTION]: 'InfoClick',
      [GEV.ASSET_TYPE]: 'FPON',
      [GEV.EVENT_LABEL]: 'HpbConnectorTile',
      [GEV.SCREEN_NAME_GA4]: `grocery-online | product | ${getCtaLocationMeta()}`,

      [GEV.AMPLITUDE_EVENT_NAME]: AEN.HPB_ICON_CLICKED,
      [GEV.AMPLITUDE_VERTICAL]: 'grocery-online',
      [GEV.AMPLITUDE_CTA_LOCATION]: {
        pageName: getPageTypeByUrl(),
        pageMeta: getCtaLocationMeta() || [],
      },
      [GEV.AMPLITUDE_CTA_SUBLOCATION]: ['hcs information'],
      [GEV.AMPLITUDE_CTA_SUBLOCATION_SECTION_TYPE]: 'popup',
    }
    track(event)
    // side sheet impressions for GA
    this.hpbImpressionSideSheet()
  }

  hpbPopConnectorClickedGA(gaMessage) {
    const { track } = this.props
    const data = {
      [GEV.EVENT]: 'hpb_popup_connector_clicked',
      [GEV.EVENT_CAT]: 'HpbApp',
      [GEV.EVENT_ACTION]: 'PopupClick',
      [GEV.ASSET_TYPE]: 'FPON',
      [GEV.EVENT_LABEL]: 'HpbConnectorTile',
      [GEV.SCREEN_NAME_GA4]: `grocery-online | product | ${getCtaLocationMeta()}`,
      [GEV.GA_MESSAGE]: gaMessage,
    }
    track(data)
  }

  hpbPopConnectorClickedAmp(ampMessage) {
    const { track } = this.props
    const data = {
      [GEV.AMPLITUDE_EVENT_NAME]: AEN.HPB_INFO_POPUP_CONNECTOR_CLICKED,
      [GEV.AMPLITUDE_VERTICAL]: 'grocery-online',
      [GEV.AMPLITUDE_CTA_LOCATION]: {
        pageName: getPageTypeByUrl(),
        pageMeta: getCtaLocationMeta() || [],
      },
      [GEV.AMPLITUDE_CTA_SUBLOCATION]: ['hcs information'],
      [GEV.AMPLITUDE_CTA_SUBLOCATION_SECTION_TYPE]: 'popup',
      [GEV.AMPLITUDE_MESSAGE]: ampMessage,
    }
    track(data)
  }

  productDetailsCardEvent({
    eventAction,
    eventCat,
    value,
    amplitudeEventName,
    delta,
  }) {
    const { data, track, checkoutAddress, countOf, remoteConfig, router } =
      this.props
    const { ratingsConfig } = this.state
    const productInfo = data.product.data.page.entity
    const productDetails = data.product.data.page.layouts[0]
    const storeSpecific = productDetails.value.storeSpecificData[0]
    const categoryList = fetchCategory(productInfo.primaryCategory)
    const offerPrice = (storeSpecific.mrp - storeSpecific.discount).toFixed(2)
    const statistics = productDetails?.value?.reviews?.statistics || {}
    const { bulkOrderThreshold, stockOverride } = productDetails
    const storeBulkOrderThreshold =
      (stockOverride && stockOverride.storeBulkOrderThreshold) || 0
    const itemIsOutOfStock = isOutOfStock({
      value: countOf(productDetails),
      stock: storeSpecific.stock,
      unlimitedStock: storeSpecific && storeSpecific.unlimitedStock,
      bulkOrderThreshold,
      storeBulkOrderThreshold,
      checkoutAddress,
    })
    const isProductBoughtBefore =
      productDetails?.value?.pastPurchases &&
      isBoughtBefore(productDetails?.value?.pastPurchases)
        ? 'yes'
        : 'no'
    const productOffers = productDetails?.value?.offers || []

    const event = {
      [GEV.EVENT_CAT]: eventCat,
      [GEV.EVENT_ACTION]: eventAction,
      [GEV.EVENT_LABEL]: 'Loc=ProductDetail',
      [GEV.PROD_ID]: getNCheck(productInfo, 'clientItemId', ''),
      [GEV.PRODUCT_ID_ZOP]: getNCheck(productInfo, 'id', ''),
      [GEV.PROD_NAME]: getNCheck(productInfo, 'name', ''),
      [GEV.PROD_CUR]: getNCheck(storeSpecific, 'currency.name', ''),
      [GEV.PROD_QUANT]: value ? value.toString() : '0',
      [GEV.PROD_BRAND]: getNCheck(productInfo, 'brand.name', ''),
      [GEV.RETAIL_PRICE]: parseFloat(getNCheck(storeSpecific, 'mrp', ''))
        .toFixed(2)
        .toString(),
      [GEV.OFFER_PRICE]: offerPrice ? offerPrice.toString() : '',
      [GEV.PROD_CAT]: 'Retail',
      [GEV.INVTRY_COUNT]: getNCheck(storeSpecific, 'stock', ''),
      [GEV.PAGE_TYPE]: PAGE_TYPES.PRODUCT_DETAIL,
      [GEV.AMPLITUDE_CTA_LOCATION]: {
        pageName: getPageTypeByUrl(),
        pageMeta: getCtaLocationMeta() || [],
      },
      [GEV.AMPLITUDE_2CLICK_CALL_TO_ACTION_LOCATION]:
        router?.query?.utm_medium === 'swa'
          ? `grocery-online | store weekly ads pdf | ${router?.query?.utm_campaign}`
          : {
              pageName: getPageTypeByUrl(
                sessionStorage.getItem('previousRoute')
              ),
              pageMeta: getPreviousCtaLocationMeta(),
            },
      [GEV.AMPLITUDE_EVENT_NAME]: amplitudeEventName,
      [GEV.PRODUCT_RATING]: productInfo?.reviews?.statistics?.average,
      [GEV.PROMOTION_COUNT]: productOffers.length,
      [GEV.PROMOTION_TYPES]: compact(
        productOffers.map(offer => offer.metaData?.sapReference)
      ),
      [GEV.PROMOTION_DESCRIPTIONS]: compact(
        productOffers.map(offer => offer.description)
      ),
      [GEV.AMPLITUDE_PRODUCT_QUANTITY]: delta,
      [GEV.AMPLITUDE_IS_PAST_PURCHASE]: isProductBoughtBefore,
      ...getAddAndRemoveFromCartEcommerceEvent({
        productInfo: productDetails.value,
        eventAction,
        categoryList,
        storeSpecific,
        itemIsOutOfStock,
        remoteConfig,
        checkoutAddress,
        statistics,
        shouldTrackReviews: Boolean(
          eventAction === 'AddToCart' &&
            ratingsConfig?.isFeatureEnabled &&
            ratingsConfig?.isPdpStarsEnabled
        ),
      }),
    }

    if (productInfo.metaData && productInfo.metaData['Storage Information']) {
      event[[GEV.STORAGE]] = productInfo.metaData['Storage Information']
    }
    /* istanbul ignore if */
    if (['AddToCart', 'RemoveFromCart'].includes(eventAction)) {
      event[[GEV.DIMENSION97]] =
        isCitrusProductTrackingEnabled(this.props.remoteConfig) &&
        this.props.router?.query?.adId
          ? `ct_${this.props.router.query.adId}`
          : ''
    }

    if (eventAction === 'AddToCart') {
      // Placing this timeout because when the user presses the add-to-cart button,
      // it takes time for the cart items to update beacuse of /cart POST API call
      // I have observed this behavior on the PDP page with this button specifically.
      setTimeout(() => {
        const dyPayload = trackingAddToCartForDY(
          productDetails.value,
          this.props?.cartItems,
          delta,
          this.props?.metaData
        )
        track({ ...dyPayload })
      }, 2000)
    }

    const keys = Object.keys(categoryList)
    keys.forEach(item => {
      event[item] = categoryList[item]
    })
    track(event)

    if (eventAction === 'AddToCart') {
      if (this.state.atcData) {
        this.updateAddToCartData(1)
      } else {
        this.setState(
          {
            atcData: {
              data: { ...this.props, details: productDetails?.value },
              inventoryStatus:
                event[GEV.ECOMMERCE].add.products[0][GEV.ECOMM_DIMENSION61],
              quantity: 1,
            },
          },
          this.trackSegmentAddToCart()
        )
      }
    } else if (eventAction === 'RemoveFromCart') {
      if (this.state.atcData) {
        this.updateAddToCartData(-1)
      }
      const quantity = event[GEV.ECOMMERCE].remove.products[0][GEV.QUANTITY]
      this.trackSegmentRemoveFromCart(
        { ...this.props, details: productDetails?.value },
        event[GEV.ECOMMERCE].remove.products[0][GEV.ECOMM_DIMENSION61],
        quantity
      )
    }
  }

  updateAddToCartData(diff) {
    if (diff === -1 && this.state.atcData?.quantity === 1) {
      this.setState({ atcData: null })
    } else {
      this.setState(
        ({ atcData }) => ({
          atcData: { ...atcData, quantity: atcData.quantity + diff },
        }),
        this.trackSegmentAddToCart()
      )
    }
  }

  scrollToSimilarProducts = () => {
    const header = document.getElementById('header-container')
    const headerHeight = header.getBoundingClientRect().height

    this.setState({ headerHeight, visibleOnScroll: true }, () => {
      if (this.similarProductsRef.current) {
        this.similarProductsRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      }
    })
  }

  getMetaData() {
    const layouts = this.props?.data?.product?.data?.page?.layouts
    const metaData = layouts?.find(
      layout => layout?.name === 'ProductCollection'
    )?.value?.collection?.metaInfo

    return metaData || {}
  }

  trackSegmentAddToCart() {
    if (this.state.atcData) {
      const { data, inventoryStatus, quantity } = this.state.atcData
      const { indexName = null, queryId = null } = this.getMetaData()
      trackProductAddedToCartEvent(
        createProductAddedToCartEventParams(
          data,
          inventoryStatus,
          quantity,
          indexName,
          queryId,
          true
        )
      )
      this.setState({ atcData: null })
    }
  }

  trackSegmentRemoveFromCart(product, inventoryStatus, quantity) {
    trackProductRemovedFromCartEvent(
      createProductRemovedFromCartEventParams(
        product,
        inventoryStatus,
        quantity
      )
    )
  }

  // Capturing AddToCart and RemoveFromCart actions.
  // On the basis of delta value we switch action type.
  // For sending event we are calling productDetailsCardEvent function.
  productCartAction(count, delta) {
    const value = count + delta
    if (delta >= 1) {
      this.productDetailsCardEvent({
        eventAction: 'AddToCart',
        eventCat: 'Ecommerce-Engagement',
        amplitudeEventName: AEN.PRODUCT_ADDED_TO_CART,
        value,
        delta,
      })
    } else {
      this.productDetailsCardEvent({
        eventAction: 'RemoveFromCart',
        eventCat: 'Ecommerce-Engagement',
        amplitudeEventName: AEN.PRODUCT_REMOVED_FROM_CART,
        value,
        delta,
      })
    }
  }

  handleShare(e, dataForShare) {
    if (navigator.share) {
      navigator
        .share({
          title: dataForShare.title,
          url: window && window.location.href,
        })
        .then(val => val)
        .catch(error => error)
    } else {
      const url = window.location.href
      window.location.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        url
      )}`
    }
  }

  handleExpandedOffersUpdate(id) {
    this.setState({
      expandedOffers: { ...this.state.expandedOffers, [id]: true },
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.router?.query?.slug !== this.props.router?.query?.slug) {
      if (this.state.selectedImageIndex) {
        this.setState({ selectedImageIndex: 0, currentImage: null })
      } else {
        this.setState({ currentImage: null })
      }
    }

    const { product } = this.props.data
    const pageProps = product && product.data ? product.data.page : {}
    const { product: prevProduct } = prevProps.data
    const prevPageProps =
      prevProduct && prevProduct.data ? prevProduct.data.page : {}

    /* istanbul ignore if  */
    if (
      pageProps.entity &&
      prevPageProps.entity &&
      pageProps.entity.clientItemId !== prevPageProps.entity.clientItemId
    ) {
      const layout = pageProps?.layouts[0] || {}
      const tags = layout?.value?.tags || []
      const isJwcTagApplicable = isJwcTag(tags)
      if (prevState.isJwcTagApplicable !== isJwcTagApplicable) {
        this.setState({ isJwcTagApplicable })
      }
      this.productDetailView()
      this.checkIfSellerInfoAvailable()
    }
  }

  onHandleTrackOnBrandClick(brandSlug) {
    const eventData = {
      [GEV.EVENT_CAT]: 'Ecommerce-Engagement',
      [GEV.EVENT_ACTION]: 'BrandClick',
      [GEV.EVENT_LABEL]: `Label=${brandSlug}`,
    }
    this.props.track(eventData)
  }

  onHandleTrackOnSellerClick(sellerSlug) {
    const { checkoutAddress } = this.props
    const eventData = {
      [GEV.AMPLITUDE_EVENT_NAME]: AEN.SELLER_CLICKED,
      [GEV.EVENT_CAT]: 'Ecommerce-Engagement',
      [GEV.EVENT_ACTION]: 'SellerClick',
      [GEV.EVENT_LABEL]: `Label=${sellerSlug}`,
      [GEV.AMPLITUDE_CTA_LOCATION]: {
        pageName: getPageTypeByUrl(),
        pageMeta: getCtaLocationMeta() || [],
      },
      [GEV.FUL_TYPE]: checkoutAddress.storeType,
    }
    this.props.track(eventData)
  }

  renderShortlistAndShare({ iconsPosition, price, details, dataForShare }) {
    const { clientX, clientY, showList } = this.state
    const { isLoggedIn, router, countOf } = this.props
    const { asPath } = router || {}
    return (
      <IconDiv isInside={iconsPosition === 'insideBox'} pointer>
        {price > 0 ? (
          isLoggedIn ? (
            <Fragment>
              <div
                tabIndex={0}
                role="button"
                aria-label="Add to favourites"
                data-testid="addToFavourites"
                onClick={event => this.handleShowList(event, countOf(details))}
                onKeyDown={e =>
                  (e.key === ' ' || e.key === 'Enter') &&
                  this.handleShowList(e, countOf(details))
                }
              >
                {this.props.wishlistConsumer.includes(details) ? (
                  <FavouriteActiveIcon
                    width="22"
                    height="22"
                    data-testid="favourite-active"
                    color={defaultTheme.ColorBaseBrandPrimary500}
                  />
                ) : (
                  <FavouriteInactive
                    width="22"
                    height="22"
                    data-testid="favourite-inactive"
                    color={defaultTheme.ColorBaseBrandPrimary500}
                  />
                )}
              </div>
              {showList && (
                <ShoppingListPopup
                  details={details}
                  position={{ clientX, clientY }}
                  isOpen={showList}
                  onClose={() => this.setState({ showList: false })}
                />
              )}
            </Fragment>
          ) : (
            <a
              href={
                asPath === '/'
                  ? `/login`
                  : `/login?redirect=${encodeURIComponent(asPath)}`
              }
            >
              <FavouriteInactive
                height="24"
                width="24"
                title="favourite"
                data-testid="favourite-inactive"
                color={defaultTheme.ColorBaseBrandPrimary500}
              />
            </a>
          )
        ) : (
          ''
        )}
        <div>
          <Share
            tabIndex={0}
            aria-label="Share product"
            data-testid="shareProduct"
            role="button"
            onClick={event => {
              this.extraEventTracking(event, countOf(details))
              this.handleShare(event, dataForShare)
            }}
            onKeyDown={e => {
              if (e.key === ' ' || e.key === 'Enter') {
                this.extraEventTracking(e, countOf(details))
                this.handleShare(e, dataForShare)
              }
            }}
            width="22"
            height="22"
            color={defaultTheme.ColorBaseBrandPrimary500}
          />
        </div>
      </IconDiv>
    )
  }

  renderSellerInfo({
    viewType = 'desktop',
    productDetails = {},
    itemIsOutOfStock,
    deltime,
  }) {
    if (!isEmpty(productDetails) && !isEmpty(productDetails?.seller)) {
      const sellerInfo = productDetails.seller
      const isDonation = sellerInfo.config?.sellerType === 'DONATION'
      const { isEnabled: isNewSellerInfoEnabled } = getConfigFor(
        SPLIT_FEATURES.FE_JOURNEY_NEW_SELLER_INFO
      )
      const InfoWrapper =
        viewType === 'belowDesktop'
          ? StyledProductInfo
          : StyledProductInfoDesktop
      return (
        <InfoWrapper data-testid="seller-info-card">
          <StyledSellerInfoCard>
            <StyledSellerInfoCardSection style={{ marginBottom: 0 }}>
              <div>
                <SellerRow>
                  <StyledSellerLogo>
                    {sellerInfo.logo ? (
                      <img src={sellerInfo.logo} alt="seller-logo" />
                    ) : (
                      <React.Fragment>
                        <Media query={SCREEN_SIZE.From.Desktop}>
                          <img src={SellerNoImgDesktop} alt="seller-logo" />
                        </Media>
                        <Media query={SCREEN_SIZE.Below.Tablet}>
                          <img src={SellerNoImgMobile} alt="seller-logo" />
                        </Media>
                      </React.Fragment>
                    )}
                  </StyledSellerLogo>
                  <StyledSellerDetails>
                    <DetailSection1>
                      <Media query={SCREEN_SIZE.From.Desktop}>
                        {!isDonation && <span>Sold by:</span>}
                        <TruncatedText clamp={2}>
                          <strong>{sellerInfo.name}</strong>
                        </TruncatedText>
                        <TruncatedText clamp={2}>
                          <span>
                            {isDonation ? 'Donation' : sellerInfo.description}
                          </span>
                        </TruncatedText>
                      </Media>
                      <SingleLineTruncation>
                        <strong>{sellerInfo.name}</strong>
                        <span>{sellerInfo.description}</span>
                      </SingleLineTruncation>
                    </DetailSection1>
                    <DetailSection2>
                      <Link
                        href={`/categoryDetails?slug=${encodeURIComponent(
                          sellerInfo.slug
                        )}`}
                        as={`/category/${encodeURIComponent(sellerInfo.slug)}`}
                        passHref
                        prefetch={false}
                        legacyBehavior
                      >
                        <StyledSellerLink
                          onClick={() =>
                            this.onHandleTrackOnSellerClick(
                              encodeURIComponent(sellerInfo.slug)
                            )
                          }
                        >
                          {isDonation ? 'View catalogue' : 'View Shop'}
                        </StyledSellerLink>
                      </Link>
                    </DetailSection2>
                  </StyledSellerDetails>
                </SellerRow>
                <Media query={SCREEN_SIZE.From.Desktop}>
                  <MarketplaceDeliveryInfo
                    deltime={deltime}
                    itemIsOutOfStock={itemIsOutOfStock}
                    isNewSellerInfoEnabled={isNewSellerInfoEnabled}
                    isDonation={isDonation}
                  />
                </Media>
              </div>
            </StyledSellerInfoCardSection>
            <Media query={SCREEN_SIZE.Below.Desktop}>
              <MarketplaceDeliveryInfo
                deltime={deltime}
                itemIsOutOfStock={itemIsOutOfStock}
                isNewSellerInfoEnabled={isNewSellerInfoEnabled}
                isDonation={isDonation}
              />
            </Media>
          </StyledSellerInfoCard>
        </InfoWrapper>
      )
    }

    return null
  }

  renderProductSwimlane = ({ products, config }) => {
    const product = products?.collection?.product
    if (product?.length) {
      return (
        <SidePaddingDiv>
          <ProductCollection
            data={{
              ...products,
              title: config.title,
            }}
            ctaLocation={{
              pageName: CTA_LOCATION_NAME.PRODUCT_DETAIL,
              pageMeta: [this.props.data?.product?.data?.page?.entity?.slug],
            }}
            config={{
              ...config,
              layoutType: 'SCROLLER',
              loadMoreType: 'SEEALL',
              pageType: PAGE_TYPES.PRODUCT_DETAIL,
              ctaSublocation: [config?.title?.toLowerCase()],
            }}
          />
        </SidePaddingDiv>
      )
    }
    return null
  }

  hpbImpressionSideSheet() {
    this.props?.track({
      [GEV.EVENT]: 'hpb_popup_connector_viewed',
      [GEV.EVENT_CAT]: 'HpbApp',
      [GEV.EVENT_ACTION]: 'PopupImpressions',
      [GEV.ASSET_TYPE]: 'FPON',
      [GEV.EVENT_LABEL]: 'HpbConnectorTile',
      [GEV.SCREEN_NAME_GA4]: `grocery-online | product | ${getCtaLocationMeta()}`,
    })
  }

  render() {
    const { product } = this.props.data
    const page = product && product.data && product.data.page
    const layouts = page && page.layouts[0]
    const {
      expandedOffers,
      isThreeColumnLayout,
      ratingsConfig,
      enableZoom,
      visibleOnScroll,
    } = this.state
    let {
      item,
      metaData,
      images,
      pastPurchases,
      name,
      storeSpecificData,
      offers,
      bulkOrderThreshold,
      description,
      id,
      clientItemId,
      reviews,
      linkpoint,
      tagIds,
      campaignLabelImage,

      // new metadata
      displayMetadata,
    } = (layouts && layouts.value) || {}

    const { isEnabled: healthierChoiceInfoEnabled } = getConfigFor(
      SPLIT_FEATURES.HEALTHIER_CHOICE_INFO_ENABLED
    )
    const transformedDisplayMetadata = (displayMetadata || [])
      .map(_metadata => {
        const metadataValues = _metadata.value
        if (_metadata.key === 'Dietary Attributes') {
          _metadata.layoutType = 'DIETARY_LIST'
        }
        return {
          ..._metadata,
          value: metadataValues,
        }
      })
      .filter(metadata => !!metadata.value)
    description = { ...metaData, description }
    const details = layouts.value
    if (!details) {
      return null
    }

    const { stockOverride, primaryCategory } = details
    const { handlingTimeDisplayText, handlingTimeTrackingText, deltime } =
      getHandlingTimeDisplayText(
        details,
        this.props.checkoutAddress?.storeId,
        true
      )
    const storeBulkOrderThreshold =
      (stockOverride && stockOverride.storeBulkOrderThreshold) || 0

    const maxPurchasableStock =
      (stockOverride && stockOverride.maxPurchasableStock) || Infinity

    const mapImageUrl =
      images &&
      images.map(ele => {
        return {
          imageUrl: `${ele}?w=400&q=70`,
        }
      })
    const DataForImageSlideShow = {
      images: mapImageUrl || [],
    }
    const currency =
      this.props.data &&
      this.props.data.organizationData &&
      this.props.data.organizationData.currency
    if (this.props.checkoutAddress && this.props.checkoutAddress.storeId) {
      storeSpecificData =
        details.storeSpecificData &&
        details.storeSpecificData.filter(
          item => item && item.storeId === this.props.checkoutAddress.storeId
        )
      if (!storeSpecificData || storeSpecificData.length === 0) {
        storeSpecificData = details.storeSpecificData
      }
    } else {
      storeSpecificData = details.storeSpecificData
    }

    if (storeSpecificData && storeSpecificData.length === 0) {
      storeSpecificData = [
        {
          ...details.storeSpecificData[0],
          stock: 0,
          unlimitedStock: false,
        },
      ]
    }
    const {
      status: storeStatus,
      stock,
      unlimitedStock,
    } = storeSpecificData && storeSpecificData[0]
    let dataForPriceDetails = [
      {
        ...storeSpecificData[0],
        currency,
      },
    ]
    const selectedKeys = [
      'Key Information',
      'Country of Origin',
      'Dietary Attributes',
      'Preparation',
      'Storage Information',
      'Ingredients',
      'Nutritional Data',
      'description',
    ]

    const dataForShare = {
      title: name,
    }

    const finalDescription = selectedKeys
      .filter(key => description[key])
      .map(key => ({
        title: key,
        data: description[key],
      }))

    // Complementary Products
    const complementaryProductsLayout = page?.layouts?.find(
      layout => layout?.name === 'ComplementaryProducts'
    )
    const complementaryProducts = complementaryProductsLayout?.value
    const complementaryProductsConfig = {
      ...complementaryProductsLayout?.data,
      slug: this.props?.data?.query?.slug,
      clientItemId: this.props?.data?.product?.data?.page?.entity?.clientItemId,
      metaData: {
        ...this.state.complementaryProductsData?.metaData,
        isDyEvent: true,
        isDyEngagement: true,
      },
    }
    const complementaryProductsPosition =
      this.getComplementarySwimlanePosition()
    const complementaryProductsDisplayTitle = complementaryProducts?.title
    const complementaryProductsLoc = `ProductWidget-${(
      complementaryProducts?.title || ''
    )
      .replace(',', '')
      .replace(/\s/g, '')}`
    const complementaryProductList = this.state.complementaryProductsData
      ? {
          collection: {
            ...this.state.complementaryProductsData,
          },
          title: complementaryProductsDisplayTitle,
        }
      : {}

    // Similar Products
    const similarProducts = page?.layouts?.find(
      layout => layout?.name === 'ProductCollection'
    )?.value

    let similarProductCollection = similarProducts?.collection?.product
    if (similarProductCollection) {
      similarProductCollection = similarProductCollection.filter(
        prod => prod.item.id !== item.id
      )
    }
    const price = +(dataForPriceDetails && dataForPriceDetails[0].mrp) || 0
    const similarProductsConfig =
      page.layouts && page.layouts[1] && page.layouts[1].data

    const { sp, otherOffers } = offers ? filterSimplePromotion(offers) : {}

    offers = otherOffers

    const { isPwpApplicable, pwpDiscount } = getPwpOffer(offers, price)
    if (pwpDiscount) {
      dataForPriceDetails = [
        { ...dataForPriceDetails[0], discount: pwpDiscount },
      ]
    }
    const hasOffers = Boolean(sp || (offers && offers.length))
    const itemIsOutOfStock = isOutOfStock({
      value: this.props.countOf(details),
      stock: storeSpecificData[0] && storeSpecificData[0].stock,
      unlimitedStock,
      bulkOrderThreshold,
      storeBulkOrderThreshold,
      checkoutAddress: this.props.checkoutAddress,
    })
    if (details.brand) {
      dataForPriceDetails[0].brand = details.brand
    }
    const minCountToShowRatings = ratingsConfig?.minCountToShowRatings || 4
    const isWriteReviewEnabled =
      ratingsConfig.writeReviewsEnabled &&
      this.props.isLoggedIn &&
      pastPurchases?.orderCount > 0
    const productSlug = this.props.data?.query?.slug
    const { productStatus, description: notificationDescription } =
      getFindSimilarSectionConfig(
        storeStatus,
        itemIsOutOfStock,
        this.props.checkoutAddress?.pincode
      )
    return (
      <React.Fragment>
        <BreadcrumbContainerFromTablet>
          <Breadcrumb category={primaryCategory} />
        </BreadcrumbContainerFromTablet>
        <ProductDetailsPreviewContainer>
          <div>
            <ToolbarContainer isThreeColumnLayout={isThreeColumnLayout}>
              <BreadcrumbContainerOnMobile>
                <Breadcrumb category={primaryCategory} />
              </BreadcrumbContainerOnMobile>
              <Media query={SCREEN_SIZE.From.Desktop}>
                {!isThreeColumnLayout &&
                  this.renderShortlistAndShare({
                    iconsPosition: 'outsideBox',
                    price,
                    details,
                    wishlistConsumer: this.props.wishlistConsumer,
                    dataForShare,
                  })}
              </Media>
              <Media query={SCREEN_SIZE.Below.Tablet}>
                {this.renderShortlistAndShare({
                  iconsPosition: 'outsideBox',
                  price,
                  details,
                  wishlistConsumer: this.props.wish,
                  dataForShare,
                })}
              </Media>
            </ToolbarContainer>
            <ImageAndDetailsContainer>
              <StyledMedia id="zoomTarget" query={SCREEN_SIZE.From.Tablet}>
                <ImgAndCarouselDiv
                  isThreeColumnLayout={this.state.isThreeColumnLayout}
                >
                  <ImgDiv>
                    {images && enableZoom ? (
                      <ReactImageZoom
                        width={344}
                        height={344}
                        alt="Product Image"
                        img={
                          this.state.currentImage !== null
                            ? `${this.state.currentImage}?w=1200&q=70`
                            : `${images[0]}?w=1200&q=70`
                        }
                        offset={{ vertical: 0, horizontal: 10 }}
                        zoomWidth={344}
                      />
                    ) : images && !enableZoom ? (
                      <StyledImg
                        src={`${this.state.currentImage}?w=400&q=70`}
                      />
                    ) : (
                      <NoImg />
                    )}
                  </ImgDiv>
                  <CarouselDiv
                    isThreeColumnLayout={this.state.isThreeColumnLayout}
                  >
                    <Carousel
                      hasMore={false}
                      infiniteScrolling={false}
                      hideArrow
                    >
                      {Array.isArray(images) &&
                        images.map((element, index) => {
                          const isCurrentImageActive =
                            index === this.state.selectedImageIndex
                          return (
                            <Div
                              isThreeColumnLayout={
                                this.state.isThreeColumnLayout
                              }
                              id={`carousel-${index}`}
                              data-testid={`carousel-${index}`}
                              tabIndex={0}
                              onKeyDown={e =>
                                (e.key === ' ' || e.key === 'Enter') &&
                                this.setState({
                                  selectedImageIndex: index,
                                  currentImage: images[index],
                                })
                              }
                              key={element + index}
                              onClick={() =>
                                this.setState({
                                  selectedImageIndex: index,
                                  currentImage: images[index],
                                })
                              }
                              onMouseOver={() => {
                                this.setState({
                                  selectedImageIndex: index,
                                  currentImage: images[index],
                                })
                              }}
                              selected={isCurrentImageActive}
                            >
                              <ButtonCarosoul
                                type="button"
                                aria-label="View product image"
                              >
                                <Img
                                  src={`${
                                    isCurrentImageActive
                                      ? `${element}?w=400&q=70`
                                      : `${element}?w=108&q=70`
                                  }`}
                                  alt="Product-image"
                                />
                              </ButtonCarosoul>
                            </Div>
                          )
                        })}
                    </Carousel>
                  </CarouselDiv>
                </ImgAndCarouselDiv>
              </StyledMedia>
              <ImageSlideShowDiv>
                <ImageSlideShow
                  data={DataForImageSlideShow}
                  config={{
                    ...tempData.config,
                    ctaLocation: {
                      pageName: CTA_LOCATION_NAME.PRODUCT_DETAIL,
                      pageMeta: [
                        this.props.data?.product?.data?.page?.entity?.slug,
                      ],
                    },
                  }}
                  stopAutoScroll
                  clickLessImageSlideShow
                  noResize
                  objectFitType={'cover'}
                />
              </ImageSlideShowDiv>
              <DetailsDiv>
                <MiniToolbarContainer className="tagWrapper">
                  <ProductCampaignLabel
                    tagIds={tagIds}
                    isDetail
                    campaignLabelImage={campaignLabelImage}
                  />
                  {isPwpApplicable && (
                    <PwpFlag size="small" weight="bold" color="#ffffff">
                      PWP
                    </PwpFlag>
                  )}
                  {!isPwpApplicable && hasOffers && (
                    <PwpFlag size="small" weight="bold" color="#ffffff">
                      Offer
                    </PwpFlag>
                  )}
                  <Media query={SCREEN_SIZE.From.Desktop}>
                    {isThreeColumnLayout &&
                      this.renderShortlistAndShare({
                        iconsPosition: 'insideBox',
                        price,
                        details,
                        wishlistConsumer: this.props.wishlistConsumer,
                        dataForShare,
                      })}
                  </Media>
                </MiniToolbarContainer>
                <PriceDetails
                  data={dataForPriceDetails}
                  linkpoint={linkpoint}
                  handleTrackOnBrandClick={this.onHandleTrackOnBrandClick}
                  name={name}
                  metaData={description}
                  simplePromo={sp}
                />
                <StyledFlex>
                  {ratingsConfig?.isFeatureEnabled &&
                    ratingsConfig?.isPdpStarsEnabled && (
                      <RatingStars
                        ratingsconfig={ratingsConfig}
                        average={reviews?.statistics?.average}
                        ratingaverage={reviews?.statistics?.averageDisplay}
                        displayratings={reviews?.statistics?.totalDisplay}
                        ratingsrange={reviews?.statistics?.range}
                        distribution={reviews?.statistics?.distribution}
                        total={reviews?.statistics?.total}
                        isplp={false}
                        clientItemId={clientItemId}
                        isWriteReviewEnabled={isWriteReviewEnabled}
                      />
                    )}
                  {isWriteReviewEnabled && (
                    <Link
                      href={`/productReview?slug=${productSlug}`}
                      as={`/review/${productSlug}`}
                      passHref
                      prefetch={false}
                      legacyBehavior
                    >
                      <StyledWriteReview>
                        <img src={WriteIcon} />
                        <span>Write a review</span>
                      </StyledWriteReview>
                    </Link>
                  )}
                </StyledFlex>
                {this.state.isJwcTagApplicable && (
                  <JwcTag remoteConfig={this.props.remoteConfig} />
                )}
                {productStatus !== PRODUCT_STATUS.AVAILABLE ? (
                  <FindSimilarSection
                    layout="web"
                    productStatus={productStatus}
                    description={notificationDescription}
                    scrollToSimilarProducts={this.scrollToSimilarProducts}
                  />
                ) : (
                  <CounterFixed>
                    <CartCounter
                      details={details}
                      price={price}
                      buttonStyle={StyledCartButtonInProductDetail}
                      counterStyle={StyledCounterInProductDetail}
                      value={this.props.countOf(details)}
                      onValueChange={({ delta }) => {
                        this.props.update(
                          {
                            ...details,
                            adId: this.props.router?.query?.adId,
                          },
                          delta
                        )
                        this.productCartAction(
                          this.props.countOf(details),
                          delta
                        )
                      }}
                      stock={stock}
                      unlimitedStock={unlimitedStock}
                      bulkOrderThreshold={bulkOrderThreshold}
                      storeBulkOrderThreshold={storeBulkOrderThreshold}
                      maxPurchasableStock={maxPurchasableStock}
                      quantityAdjustedmessage={
                        this.props.quantityAdjustedmessage
                      }
                      handlingTimeDisplayText={handlingTimeDisplayText}
                      handlingTimeTrackingText={handlingTimeTrackingText}
                      isEnabledStoreHandlingTime={true}
                      checkoutAddress={this.props.checkoutAddress}
                    />
                  </CounterFixed>
                )}
                {this.fetchPDPVoucherSwimlane(id, primaryCategory, details)}
                {offers && (
                  <PromoOfferContainer
                    isThreeColumnLayout={this.state.isThreeColumnLayout}
                    tabIndex={0}
                    role="button"
                  >
                    {offers.map((e, i) => (
                      <PromoOffers
                        data-testid={'clientItemId'}
                        data={e}
                        key={i}
                        showArrow={expandedOffers[e.id]}
                        clientItemId={clientItemId}
                        name={name}
                      />
                    ))}
                  </PromoOfferContainer>
                )}
              </DetailsDiv>
              {this.state.isThreeColumnLayout &&
                this.renderSellerInfo({
                  viewType: 'desktop',
                  productDetails: details,
                  checkoutAddress: this.props.checkoutAddress,
                  itemIsOutOfStock,
                  deltime,
                })}
            </ImageAndDetailsContainer>
          </div>

          {this.state.isThreeColumnLayout &&
            this.renderSellerInfo({
              viewType: 'belowDesktop',
              productDetails: details,
              checkoutAddress: this.props.checkoutAddress,
              itemIsOutOfStock,
              deltime,
            })}

          {productStatus !== PRODUCT_STATUS.AVAILABLE && (
            <FindSimilarSection
              layout="mobile"
              productStatus={productStatus}
              description={notificationDescription}
              scrollToSimilarProducts={this.scrollToSimilarProducts}
            />
          )}

          {Boolean(offers?.length) && (
            <OfferDetailWrapper>
              {offers.map((offer, index) => {
                return (
                  <OfferDetails
                    key={index}
                    data={offer}
                    id={offer.id}
                    pid={id}
                    checkoutAddress={this.props.checkoutAddress}
                    onOfferLoad={this.handleExpandedOffersUpdate}
                    pageType={PAGE_TYPES.PRODUCT_DETAIL}
                  />
                )
              })}
            </OfferDetailWrapper>
          )}

          {complementaryProductsPosition === 'top' &&
            complementaryProductList?.collection?.product?.length > 0 && (
              <TopComplementaryProductsSwimlaneContainer>
                {this.state.complementaryProductsDataLoading ? (
                  <Loader />
                ) : (
                  this.renderProductSwimlane({
                    products: complementaryProductList,
                    config: {
                      ...complementaryProductsConfig,
                      title: complementaryProductsDisplayTitle,
                      loc: complementaryProductsLoc,
                    },
                  })
                )}
              </TopComplementaryProductsSwimlaneContainer>
            )}

          {displayMetadata ? (
            <CenterDiv>
              <ProductDescriptionContainer data-testid="productDescription">
                {transformedDisplayMetadata.map(metadata => {
                  return (
                    <ProductComplexAttribute
                      key={metadata.key}
                      metadata={metadata}
                      onHealthierChoiceInfoPress={() => {
                        this.trackHBPDietaryGA()
                        this.setState({
                          isHealthierChoiceInfoSheetOpen: true,
                        })
                      }}
                    />
                  )
                })}
              </ProductDescriptionContainer>
            </CenterDiv>
          ) : (
            finalDescription.length > 0 && (
              <CenterDiv>
                <ProductDescriptionContainer data-testid="productDescription">
                  {finalDescription.map(({ title, data }, index) => {
                    let items = data
                    if (
                      healthierChoiceInfoEnabled &&
                      title === 'Dietary Attributes'
                    ) {
                      items = [
                        ...items.filter(item => {
                          const lowercaseItem = (item || '')
                            .toLowerCase()
                            .replace(/[^a-z]+/g, '')
                          return lowercaseItem !== 'healthierchoice'
                        }),
                      ]
                    }
                    return (
                      <ProductDescription
                        title={title}
                        data={items}
                        key={index}
                        onHealthierChoiceInfoPress={() => {
                          this.trackHBPDietaryGA()
                          this.setState({
                            isHealthierChoiceInfoSheetOpen: true,
                          })
                        }}
                      />
                    )
                  })}
                </ProductDescriptionContainer>
              </CenterDiv>
            )
          )}

          {ratingsConfig?.isFeatureEnabled &&
            ratingsConfig?.isReviewEnabled &&
            reviews?.statistics?.total >= parseInt(minCountToShowRatings) && (
              <StyledWrap>
                <StyledSection>
                  {isWriteReviewEnabled && (
                    <StyledWriteWrap>
                      <h5>Reviews</h5>
                      <Link
                        href={`/productReview?slug=${productSlug}`}
                        as={`/review/${productSlug}`}
                        passHref
                        prefetch={false}
                        legacyBehavior
                      >
                        <StyledWriteReview>
                          <img src={WriteIcon} />
                          <span>Write a review</span>
                        </StyledWriteReview>
                      </Link>
                    </StyledWriteWrap>
                  )}
                  <div
                    id="fpBVContainer"
                    data-bv-show="reviews"
                    data-bv-product-id={clientItemId}
                  />
                </StyledSection>
              </StyledWrap>
            )}

          {visibleOnScroll && (
            <Fragment>
              <SimilarProductsSwimlaneContainer
                headerHeight={this.state.headerHeight}
                ref={this.similarProductsRef}
                complementarySwimlaneEnabled={
                  complementaryProductsPosition === 'bottom' &&
                  complementaryProductList?.collection?.product?.length > 0
                }
              >
                {this.renderProductSwimlane({
                  products: similarProducts,
                  config: {
                    ...similarProductsConfig,
                    title: 'Similar Products',
                    loc: 'ProductWidget-SimilarProducts',
                  },
                })}
              </SimilarProductsSwimlaneContainer>
              {complementaryProductsPosition === 'bottom' &&
                (this.state.complementaryProductsDataLoading ? (
                  <Loader />
                ) : (
                  this.renderProductSwimlane({
                    products: complementaryProductList,
                    config: {
                      ...complementaryProductsConfig,
                      title: complementaryProductsDisplayTitle,
                      loc: complementaryProductsLoc,
                    },
                  })
                ))}
              {healthierChoiceInfoEnabled ? (
                typeof window === 'undefined' ? null : (
                  <SideSheet
                    open={this.state.isHealthierChoiceInfoSheetOpen}
                    onClose={() => {
                      this.hpbPopConnectorClickedAmp('cancel')
                      this.hpbPopConnectorClickedGA('cancel')
                      this.setState({ isHealthierChoiceInfoSheetOpen: false })
                    }}
                    direction="bottom"
                    size={300}
                    loadingTime={0}
                    title="Be rewarded with Healthier Choice"
                    description=""
                    enableOverlay
                    lockBackgroundScroll
                  >
                    <HealthierChoiceInfoSheetBody
                      onLinkClick={() => {
                        this.hpbPopConnectorClickedAmp('how to get started')
                        this.hpbPopConnectorClickedGA('how_to_get_started')
                        this.setState({ isHealthierChoiceInfoSheetOpen: false })
                      }}
                    />
                  </SideSheet>
                )
              ) : null}
            </Fragment>
          )}
        </ProductDetailsPreviewContainer>
      </React.Fragment>
    )
  }
}

export default withRouter(props => (
  <TangramFairpriceProvider
    experimental={{
      Button: true,
      NotificationBanner: true,
      Text: true,
    }}
  >
    <GlobalContext.Consumer>
      {({ remoteConfig }) => (
        <EventTrackingConsumer>
          {({ track }) => (
            <CartConsumer>
              {({ update, countOf, quantityAdjustedmessage, items }) => (
                <WishlistConsumer>
                  {wishlistConsumer => (
                    <ProductDetails
                      {...props}
                      cartItems={items}
                      track={track}
                      update={update}
                      countOf={countOf}
                      remoteConfig={remoteConfig}
                      quantityAdjustedmessage={quantityAdjustedmessage}
                      wishlistConsumer={wishlistConsumer}
                    />
                  )}
                </WishlistConsumer>
              )}
            </CartConsumer>
          )}
        </EventTrackingConsumer>
      )}
    </GlobalContext.Consumer>
  </TangramFairpriceProvider>
))
